var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcConversationCreditsEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "82px",
    viewBox: "0 0 86.0 82.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145.0 -301.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.0 302.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.00000000000001 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.0 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6,0 C65.3171629,0 83.2,14.3600261 83.2,33.4049171 C83.2,45.7286202 77.1367888,55.5644635 66.1011212,61.1822334 L66.1011212,78.7657313 C66.1011212,79.2176072 65.8466118,79.6369399 65.4380116,79.8518606 C65.2517176,79.9505072 65.0449936,80 64.8406935,80 C64.5986499,80 64.3566062,79.9308457 64.1474583,79.79491 L43.9598392,66.7233913 L43.9092836,66.7257642 C43.1429851,66.7654262 42.3791105,66.8071222 41.6,66.8071222 C17.8828371,66.8071222 -4.26325641e-14,52.4470961 -4.26325641e-14,33.4049171 C-4.26325641e-14,14.3600261 17.8828371,0 41.6,0 Z M21.0285714,28.8 C18.2513681,28.8 16,30.9490332 16,33.6 C16,36.2509668 18.2513681,38.4 21.0285714,38.4 C23.8057747,38.4 26.0571429,36.2509668 26.0571429,33.6 C26.0571429,30.9490332 23.8057747,28.8 21.0285714,28.8 Z M41.6,28.8 C38.8227967,28.8 36.5714286,30.9490332 36.5714286,33.6 C36.5714286,36.2509668 38.8227967,38.4 41.6,38.4 C44.3772033,38.4 46.6285714,36.2509668 46.6285714,33.6 C46.6285714,30.9490332 44.3772033,28.8 41.6,28.8 Z M62.1714286,28.8 C59.3942253,28.8 57.1428571,30.9490332 57.1428571,33.6 C57.1428571,36.2509668 59.3942253,38.4 62.1714286,38.4 C64.9486319,38.4 67.2,36.2509668 67.2,33.6 C67.2,30.9490332 64.9486319,28.8 62.1714286,28.8 Z",
    stroke: "#666666",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConversationCreditsEmpty);
export default __webpack_public_path__ + "static/media/icConversationCreditsEmpty.a46f42807554bcebc75e57b19cb91d92.svg";
export { ForwardRef as ReactComponent };